export const COLUMNS = {
    FILE_NAME: 'fileName',
    FILE_SIZE: 'fileSize',
    INITIATOR: 'initiatorUser',
};

export const HEADERS = {
    [COLUMNS.FILE_NAME]: 'Report/File Name',
    [COLUMNS.FILE_SIZE]: 'File Size',
    [COLUMNS.INITIATOR]: 'Requester',
};

export const COLUMNS_DATA = [
    {
        columnId: COLUMNS.FILE_NAME,
        fixed: true,
        defaultWidth: 600,
        minWidth: 350,
        maxWidth: 600,
    },
    {
        columnId: COLUMNS.FILE_SIZE,
        fixed: false,
        defaultWidth: 100,
        minWidth: 50,
        maxWidth: 100,
    },
    {
        columnId: COLUMNS.INITIATOR,
        fixed: false,
        defaultWidth: 190,
        minWidth: 190,
        maxWidth: 190,
    },
];
